import { SETTING } from 'interfaces/settings';

export interface RangeConfig {
    min: number;
    max: number;
    step: number;
    unit: string;
    defaultValue: number;
}

export const RANGE_SETTING_CONFIGS: { [K in SETTING]?: RangeConfig } = {
    [SETTING.TIME_TO_DIAL]: {
        min: 0,
        max: 40,
        step: 1,
        unit: 's',
        defaultValue: 4,
    },
    [SETTING.TIME_TO_LOG]: {
        min: 0,
        max: 30,
        step: 1,
        unit: 's',
        defaultValue: 4,
    },
    [SETTING.MAX_NUMBER_LINES]: {
        min: 1,
        max: 5,
        step: 1,
        unit: '',
        defaultValue: 5,
    },
    [SETTING.HANGUP_RINGING_TIME]: {
        min: 0,
        max: 120,
        step: 1,
        unit: 's',
        defaultValue: 30,
    },
    [SETTING.HANGUP_VOICEMAIL_TIME]: {
        min: 0,
        max: 120,
        step: 1,
        unit: 's',
        defaultValue: 5,
    },
    [SETTING.AUTO_PROGRESS_TIME]: {
        min: 0,
        max: 120,
        step: 1,
        unit: 's',
        defaultValue: 10,
    },
};

export function getRangeConfig(setting: SETTING): RangeConfig {
    const config = RANGE_SETTING_CONFIGS[setting];
    if (!config) {
        throw new Error(`No range configuration found for setting: ${setting}`);
    }
    return config;
} 